import { render, staticRenderFns } from "./PersonalOrders.vue?vue&type=template&id=11063aed"
import script from "./PersonalOrders.vue?vue&type=script&lang=js"
export * from "./PersonalOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports